import styled from 'styled-components';
import {
    compose,
    withProps,
    mapProps,
    setDisplayName,
    setPropTypes,
} from 'react-recompose';

import { oneOf } from 'prop-types';
import { fieldArrayPropTypes } from 'redux-form';
import { FieldArray } from 'redux-form/immutable';
import {
    Form,
    Select,
    Dropdown,
} from 'semantic-ui-react';

import { immutableToJS } from '~/utils';


const withMappedProps = mapProps(({
    fields: {
        getAll,
        push,
        remove,
    },
    meta: {
        touched,
        error,
    },
    ...rest
}) => {
    const allValues = immutableToJS(getAll()) || [];
    return ({
        ...rest,
        onChange: (_, { value: newValues }) => {
            const removeItem = allValues.findIndex(i => !newValues.includes(i));
            const addItem = newValues.find(v => !allValues.includes(v));

            if (removeItem !== -1) {
                remove(removeItem);
            } else if (addItem) {
                push(addItem);
            } else {
                throw new Error("Don't know what to do");
            }
        },
        value: allValues,
        multiple: true,
        selection: true,
        error: Boolean(touched && error),
        message: touched ? error : '',
    });
});

const StyledFormField = styled(Form.Field)`
    && {
        ::after {
            display: block;
            margin-left: 2px;
            margin-top: 2px;
            margin-bottom: 10px;
            content: '${p => p.message }';
            font-size: 12px;
            color: #9F3A38;
        }
    }
`;

/*
 * Integration Form.Field and Redux-Form
 */
const FormField = compose(
    setDisplayName('FormField'),
    setPropTypes({
        control: oneOf([
            Form.Select,
            Select,
            Dropdown,
        ]).isRequired,
        ...fieldArrayPropTypes,
    }),
    withMappedProps,
)(StyledFormField);

export default withProps({ component: FormField })(FieldArray);
